import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueAxios from 'vue-axios'
import fetch from './services/fetch'
import './vee-validate'
import './filters'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/id'
import './assets/styles.css'

Vue.config.productionTip = false

Vue.use(VueAxios, fetch)
Vue.component('datepicker', DatePicker)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
